import { useEffect, useRef, useState } from "react";

export default function SignaturePad({ label, confirmationText, value, onChange, error }) {
  const canvasRef = useRef(null);
  const drawingRef = useRef(false);
  const hasDrawnRef = useRef(Boolean(value));
  const [hasSignature, setHasSignature] = useState(Boolean(value));

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const rect = canvas.getBoundingClientRect();
    const ratio = window.devicePixelRatio || 1;
    canvas.width = Math.max(1, Math.floor(rect.width * ratio));
    canvas.height = Math.max(1, Math.floor(rect.height * ratio));

    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#111827";
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, rect.width, rect.height);
  }, []);

  const point = (event) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    return {
      x: event.clientX - rect.left,
      y: event.clientY - rect.top
    };
  };

  const startDrawing = (event) => {
    event.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const current = point(event);
    drawingRef.current = true;
    hasDrawnRef.current = true;
    ctx.beginPath();
    ctx.moveTo(current.x, current.y);
  };

  const draw = (event) => {
    if (!drawingRef.current) return;
    event.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const current = point(event);
    ctx.lineTo(current.x, current.y);
    ctx.stroke();
  };

  const stopDrawing = () => {
    if (!drawingRef.current) return;
    drawingRef.current = false;
    if (hasDrawnRef.current) {
      const dataUrl = canvasRef.current.toDataURL("image/png");
      setHasSignature(true);
      onChange(dataUrl);
    }
  };

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    ctx.clearRect(0, 0, rect.width, rect.height);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, rect.width, rect.height);
    hasDrawnRef.current = false;
    setHasSignature(false);
    onChange("");
  };

  return (
    <div className={`signature-card${hasSignature ? " complete" : ""}${error ? " has-error" : ""}`}>
      <div className="signature-copy">
        <span className="field-label">{label}</span>
        <p>{confirmationText}</p>
      </div>
      <canvas
        ref={canvasRef}
        className="signature-canvas"
        onPointerDown={startDrawing}
        onPointerMove={draw}
        onPointerUp={stopDrawing}
        onPointerCancel={stopDrawing}
        onPointerLeave={stopDrawing}
        aria-label={label}
      />
      <div className="signature-actions">
        <span className={`checkout-photo-status${hasSignature ? " complete" : ""}`}>
          {hasSignature ? "Handtekening toegevoegd" : "Nog geen handtekening"}
        </span>
        <button type="button" className="button secondary" onClick={clear}>Handtekening wissen</button>
      </div>
      {error && <p className="error-text">{error}</p>}
    </div>
  );
}
